import { SearchParam } from '../searchParams/searchParam.ts';
import IsNullOrEmpty from './isNullOrEmpty.ts';

const GenerateSearchQuery = (searchParam: SearchParam) => {
    let query = '?';
    query += `searchTerm=${encodeURIComponent(searchParam.searchTerm)}&`;

    if (!IsNullOrEmpty(searchParam.searchType))
        query += `searchType=${encodeURIComponent(searchParam.searchType)}&`;

    if (query == '?')
        return '';

    return query.substring(0, query.length - 1);
}

export default GenerateSearchQuery;